import React from 'react'
import LoginSignUp from '../../common_components/Login_SignUp/LoginSignUp'

function SignUp() {
  return (
    <div className='signup_page'>
        <LoginSignUp 
        title = 'Sign Up'
        />
    </div>
  )
}

export default SignUp